module.exports = __webpack_public_path__ + "img/survey_hedaer.34b09d2a.png";